import React from 'react';
import { MOBILE_BATTLE_DOCK_LIFT_PX } from './mobileBattleLayoutOffsets';

/**
 * Mobile Player Preparation Bonus and Diplomatic Accord Component
 * Positioned on top of the player drone zone
 */
export const MobilePlayerBonuses = ({
  preparationBonus,
  preparationBonusUsed,
  preparationBonusPendingRef,
  playerGoesFirst,
  diplomaticAccord,
  yourTurn,
  activatePreparationBonus,
  isAutobattler = false,
  isAutobattlerSpectator = false,
  t
}) => {
  const hasPrepBonus = (preparationBonus === 'plan_ahead' || preparationBonus === 'black_market' || preparationBonus === 'team_leader') && playerGoesFirst === false;
  
  if (!hasPrepBonus && !diplomaticAccord) return null;
  
  return (
    <div
      className="player-bonuses-mobile"
      style={{
        position: "absolute",
        bottom: `${40 + MOBILE_BATTLE_DOCK_LIFT_PX}px`,
        right: "75px",
        zIndex: 1002,
        display: "flex",
        gap: "2px",
        flexDirection: "row",
        transform: "scale(0.35)",
        transformOrigin: "bottom right"
      }}
    >
      {/* Player Preparation Bonus */}
      {hasPrepBonus && (
        <div 
          style={{ 
            width: "84px",
            height: "84px",
            pointerEvents: (preparationBonusUsed || preparationBonusPendingRef.current || !yourTurn) ? 'none' : 'auto'
          }}
        >
          <button
            className={`preparation-bonus-button ${(preparationBonusUsed || preparationBonusPendingRef.current || !yourTurn) ? 'disabled' : ''}`}
            onClick={(e) => {
              const ok = activatePreparationBonus(e);
              if (!ok) {
                e.preventDefault();
                e.stopPropagation();
              }
            }}
            disabled={isAutobattler || isAutobattlerSpectator || preparationBonusUsed || preparationBonusPendingRef.current || !yourTurn}
            data-tooltip={
              preparationBonusUsed ? (t('battleUI.preparationBonusUsed') || 'Preparation bonus already used') :
              !yourTurn ? (t('battleUI.notYourTurn') || 'Not your turn') :
              preparationBonus === 'plan_ahead' ? t('profile.preparationBonus.planAhead') :
              preparationBonus === 'black_market' ? t('profile.preparationBonus.blackMarketDossier') :
              t('profile.preparationBonus.teamLeaderMeeting')
            }
            style={{
              width: "100%",
              height: "100%",
              border: "2px solid rgba(255, 255, 255, 0.2)",
              borderRadius: "8px",
              overflow: "hidden",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: 0,
              margin: 0,
              ...(preparationBonusUsed || preparationBonusPendingRef.current || !yourTurn ? {
                filter: 'grayscale(100%)',
                cursor: 'not-allowed',
                pointerEvents: 'none',
                background: 'rgba(30, 30, 30, 0.7)'
              } : {
                cursor: 'pointer',
                background: 'rgba(50, 50, 50, 0.5)',
                filter: 'none'
              })
            }}
          >
            <img 
              src={`/images/${preparationBonus === 'plan_ahead' ? 'plan_ahead.jpg' : 
                            preparationBonus === 'black_market' ? 'black_market_dossier.jpg' : 
                            'team_leader_briefing.jpg'}`}
              alt={preparationBonus}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                pointerEvents: "none"
              }}
            />
          </button>
        </div>
      )}
      
      {/* Player Diplomatic Accord */}
      {diplomaticAccord && (
        <div 
          style={{ 
            width: "84px",
            height: "84px"
          }}
          data-tooltip={
            diplomaticAccord === 'strategic_coordination' ? t('profile.diplomaticAccords.strategicCoordination') :
            diplomaticAccord === 'public_relations' ? t('profile.diplomaticAccords.publicRelations') :
            diplomaticAccord === 'emergency_protocol' ? t('profile.diplomaticAccords.emergencyProtocol') :
            t('profile.diplomaticAccords.commandDirective')
          }
        >
          <div
            style={{
              width: "100%",
              height: "100%",
              border: "2px solid rgba(255, 255, 255, 0.2)",
              borderRadius: "8px",
              overflow: "hidden",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: 0,
              margin: 0,
              background: 'rgba(50, 50, 50, 0.5)'
            }}
          >
            <img 
              src={`/images/${diplomaticAccord === 'strategic_coordination' ? 'strategic_coordination.jpg' : 
                            diplomaticAccord === 'public_relations' ? 'public_relations.jpg' : 
                            diplomaticAccord === 'emergency_protocol' ? 'emergency_protocol.jpg' : 
                            'command_directive.jpg'}`}
              alt={diplomaticAccord}
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                pointerEvents: "none"
              }}
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default MobilePlayerBonuses;

